import { Column, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryColumn } from 'typeorm';
import { GenericModel } from '@nsk-app/models/genericModel';
import { InformationPage } from '@nsk-app/models/informationPage';
import { MediaFile } from '@nsk-app/models/mediaFile';

@Entity()
export class InformationPageImage extends GenericModel {

  @PrimaryColumn()
  id: number;

  @Column()
  media_link_id: number;

  @Column()
  media_file_id: number;

  @Column({nullable: true})
  caption?: string;

  @Column()
  show_round: boolean;

  @ManyToOne(type => InformationPage, page => page.media, {lazy: true})
  @JoinColumn({name: 'media_link_id'})
  page: Promise<InformationPage>;

  @ManyToOne(type => MediaFile, {eager: true})
  @JoinColumn({name: 'media_file_id'})
  image: MediaFile;
}
